module.exports = __webpack_public_path__ + "static/img/dtgk.846e79c0.png";